var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "tr",
    {
      directives: [
        {
          name: "tooltip",
          rawName: "v-tooltip.top-start",
          value: {
            content: `Document id: ${_vm.data.doc.docPid}`,
            trigger: "hover",
            hideOnTargetClick: false,
            autoHide: false,
          },
          expression:
            "{\n\t\tcontent: `Document id: ${data.doc.docPid}`,\n\t\ttrigger: 'hover',\n\t\thideOnTargetClick: false,\n\tautoHide: false,\n\t}",
          modifiers: { "top-start": true },
        },
      ],
      staticClass: "document rounded",
    },
    [
      _c(
        "td",
        {
          attrs: {
            colspan: _vm.colspan
              ? _vm.colspan -
                (_vm.metadata ? _vm.metadata.length : 0) -
                (_vm.data.doc.numberOfHits ? 1 : 0)
              : undefined,
          },
        },
        [
          _c(
            "a",
            {
              staticClass: "doctitle",
              attrs: { target: "_blank", href: _vm.data.href },
            },
            [_vm._v(_vm._s(_vm.data.summary))]
          ),
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.metadata, function (meta) {
        return _c("td", { key: meta.id }, [
          _vm._v(_vm._s(_vm.data.doc.docInfo[meta.id]?.join(", ") || "")),
        ])
      }),
      _vm._v(" "),
      _vm.data.doc.numberOfHits
        ? _c("td", [_vm._v(_vm._s(_vm.data.doc.numberOfHits))])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }